export default __webpack_public_path__ + "static/media/inactiveDot.055c286d.svg";